module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteTitle":"Details","backToOverview":"Back to overview"},"de":{"siteTitle":"Details","backToOverview":"Zurück zur Übersicht"},"fr":{"siteTitle":"Détails","backToOverview":"Retour à l\u0027aperçu"},"it":{"siteTitle":"Dettagli","backToOverview":"Ritorna alla panoramica"}}')
  delete Component.options._Ctor
}
